(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exhibition-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseArchive = (section) => {
      if (!section || section.dataset.expoInitialised === 'true') return;
      const track = section.querySelector('[data-expo-track]');
      const viewport = section.querySelector('[data-expo-viewport]');
      const slides = Array.from(section.querySelectorAll('[data-expo-slide]'));
      const dots = Array.from(section.querySelectorAll('[data-expo-dot]'));
      const previous = section.querySelector('[data-expo-prev]');
      const next = section.querySelector('[data-expo-next]');
      const status = section.querySelector('[data-expo-status]');
      const dialog = section.querySelector('[data-expo-dialog]');
      const dialogImage = section.querySelector('[data-expo-dialog-image]');
      const dialogTitle = section.querySelector('[data-expo-dialog-title]');
      const dialogMeta = section.querySelector('[data-expo-dialog-meta]');
      const close = section.querySelector('[data-expo-close]');
      if (!track || !viewport || !slides.length) return;

      section.dataset.expoInitialised = 'true';
      let current = 0;
      let autoTimer;
      let dragStart;

      const update = (nextIndex) => {
        current = (nextIndex + slides.length) % slides.length;
        track.style.transform = 'translate3d(' + (-current * 100) + '%, 0, 0)';
        slides.forEach((slide, index) => {
          const active = index === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, index) => {
          const active = index === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
        if (status) status.textContent = String(current + 1) + ' / ' + String(slides.length);
      };

      const stopAutoPlay = () => {
        window.clearInterval(autoTimer);
        autoTimer = undefined;
      };
      const startAutoPlay = () => {
        const wantsAutoPlay = section.dataset.autoPlay === 'true';
        const delay = Number(section.dataset.autoPlayDelay) || 6000;
        if (!wantsAutoPlay || slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        stopAutoPlay();
        autoTimer = window.setInterval(() => update(current + 1), delay);
      };

      previous?.addEventListener('click', () => { update(current - 1); startAutoPlay(); });
      next?.addEventListener('click', () => { update(current + 1); startAutoPlay(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { update(Number(dot.dataset.expoDot)); startAutoPlay(); }));
      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); update(current - 1); startAutoPlay(); }
        if (event.key === 'ArrowRight') { event.preventDefault(); update(current + 1); startAutoPlay(); }
      });
      viewport.addEventListener('pointerdown', (event) => { dragStart = event.clientX; stopAutoPlay(); });
      viewport.addEventListener('pointerup', (event) => {
        if (typeof dragStart !== 'number') return;
        const distance = event.clientX - dragStart;
        if (Math.abs(distance) > 45) update(distance > 0 ? current - 1 : current + 1);
        dragStart = undefined;
        startAutoPlay();
      });
      viewport.addEventListener('pointercancel', () => { dragStart = undefined; startAutoPlay(); });
      section.addEventListener('mouseenter', stopAutoPlay);
      section.addEventListener('mouseleave', startAutoPlay);
      section.addEventListener('focusin', stopAutoPlay);
      section.addEventListener('focusout', (event) => { if (!section.contains(event.relatedTarget)) startAutoPlay(); });

      section.querySelectorAll('[data-expo-open]').forEach((photo) => {
        photo.addEventListener('click', () => {
          if (!dialog || !dialogImage || !dialogTitle || !dialogMeta) return;
          dialogImage.src = photo.dataset.expoSrc || '';
          dialogImage.alt = photo.dataset.expoAlt || '';
          dialogTitle.textContent = photo.dataset.expoTitle || '';
          dialogMeta.textContent = photo.dataset.expoMeta || '';
          dialog.showModal();
        });
      });
      close?.addEventListener('click', () => dialog?.close());
      dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      update(0);
      startAutoPlay();
    };

    const initialiseAll = (scope = document) => scope.querySelectorAll('[data-expo-archive]').forEach(initialiseArchive);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseAll());
    else initialiseAll();
    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  (function () {
    function initCarousels(scope) {
      scope.querySelectorAll('[data-blog-promo-carousel]').forEach(function (carousel) {
        if (carousel.dataset.carouselReady === 'true') return;
        carousel.dataset.carouselReady = 'true';

        var track = carousel.querySelector('.blog-post-promo-carousel__track');
        var slides = Array.from(track.children);
        var dots = Array.from(carousel.querySelectorAll('[data-promo-dot]'));
        var previous = carousel.querySelector('[data-promo-prev]');
        var next = carousel.querySelector('[data-promo-next]');
        var activeIndex = 0;
        var timer;

        function show(index) {
          activeIndex = (index + slides.length) % slides.length;
          track.style.transform = 'translateX(-' + activeIndex * 100 + '%)';
          slides.forEach(function (slide, slideIndex) {
            var active = slideIndex === activeIndex;
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
            if (active) slide.removeAttribute('inert');
            else slide.setAttribute('inert', '');
          });
          dots.forEach(function (dot, dotIndex) {
            dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
          });
        }

        function stop() {
          window.clearInterval(timer);
          timer = undefined;
        }

        function start() {
          stop();
          if (carousel.dataset.autoplay !== 'true' || slides.length < 2) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.hidden) return;
          if (carousel.matches(':hover') || carousel.contains(document.activeElement)) return;
          var interval = Number(carousel.dataset.interval) || 6000;
          timer = window.setInterval(function () { show(activeIndex + 1); }, interval);
        }

        previous.addEventListener('click', function () { show(activeIndex - 1); start(); });
        next.addEventListener('click', function () { show(activeIndex + 1); start(); });
        dots.forEach(function (dot, dotIndex) {
          dot.addEventListener('click', function () { show(dotIndex); start(); });
        });
        var touchStartX;
        var touchStartY;
        carousel.addEventListener('touchstart', function (event) {
          touchStartX = event.changedTouches[0].clientX;
          touchStartY = event.changedTouches[0].clientY;
          stop();
        }, { passive: true });
        carousel.addEventListener('touchend', function (event) {
          var deltaX = event.changedTouches[0].clientX - touchStartX;
          var deltaY = event.changedTouches[0].clientY - touchStartY;
          if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
            show(activeIndex + (deltaX < 0 ? 1 : -1));
          }
          start();
        }, { passive: true });
        carousel.addEventListener('mouseenter', stop);
        carousel.addEventListener('mouseleave', start);
        carousel.addEventListener('focusin', stop);
        carousel.addEventListener('focusout', function (event) {
          if (!carousel.contains(event.relatedTarget)) start();
        });
        document.addEventListener('visibilitychange', start);
        carousel.blogPromoDestroy = function () {
          stop();
          document.removeEventListener('visibilitychange', start);
        };

        show(0);
        start();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initCarousels(document); });
    } else {
      initCarousels(document);
    }
    document.addEventListener('shopify:section:load', function (event) {
      initCarousels(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-blog-promo-carousel]').forEach(function (carousel) {
        if (carousel.blogPromoDestroy) carousel.blogPromoDestroy();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reviewSection = document.getElementById('shopify-section-template--26981346738464__1775545948897575cc');
    if (reviewSection) reviewSection.style.display = 'none';

    document.querySelectorAll('.product-tabs-section').forEach(function (section) {
      var buttons = section.querySelectorAll('.product-tabs__btn');
      var panels  = section.querySelectorAll('.product-tabs__panel');

      buttons.forEach(function (btn, index) {
        btn.addEventListener('click', function () {
          var target = btn.dataset.tab;
          buttons.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          var active = section.querySelector('#tab-panel-' + target);
          if (active) active.classList.add('is-active');

          if (target === 'review') {
            if (reviewSection) {
              reviewSection.style.display = '';
              reviewSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            if (window.jdgm) window.jdgm.customWidgets.init(reviewSection);
          } else {
            if (reviewSection) reviewSection.style.display = 'none';
          }
        });

        btn.addEventListener('keydown', function (e) {
          var newIndex = null;
          if (e.key === 'ArrowRight') newIndex = (index + 1) % buttons.length;
          if (e.key === 'ArrowLeft')  newIndex = (index - 1 + buttons.length) % buttons.length;
          if (newIndex !== null) { buttons[newIndex].focus(); buttons[newIndex].click(); }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
